import * as React from "react";
import { remove } from "ramda";

type Subscribe = (id: string) => number;
type Unsubscribe = (id: string) => void;

type ZIndexContextType = {
  subscribe: Subscribe;
  unsubscribe: Unsubscribe;
};

export const ZIndexContext = React.createContext({} as ZIndexContextType);

type Props = {};

type State = {
  ids: string[];
};

class Name extends React.Component<Props, State> {
  state = {
    ids: []
  } as State;

  handleSubscribe: Subscribe = id => {
    const newState = [...this.state.ids, id];
    this.setState({
      ids: newState
    });
    return newState.length + 1000;
  };

  handleUnsubscribe: Unsubscribe = id => {
    const index = this.state.ids.indexOf(id);
    this.setState({
      ids: remove(index, 1, this.state.ids)
    });
  };

  contextPayload: ZIndexContextType = {
    subscribe: this.handleSubscribe,
    unsubscribe: this.handleUnsubscribe
  };

  render() {
    return (
      <ZIndexContext.Provider value={this.contextPayload}>
        {this.props.children}
      </ZIndexContext.Provider>
    );
  }
}

export default Name;
